import { Component, OnInit, Inject } from '@angular/core';
import { PageEvent, MatSnackBar, MatDialog } from '@angular/material';
import * as XLSX from 'xlsx';
// import { forEach } from '@angular/router/src/utils/collection';
type AOA = any[][];
import { Router, NavigationEnd } from '@angular/router';
import { HttpService } from '../../../services/http/http.service';
import { LocalstorageService } from '../../../services/localstorage/localstorage.service';
import { AddIndividualQuestionComponent } from '../add-individual-question/add-individual-question.component';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { EventManager } from '@angular/platform-browser';

import { filter } from 'rxjs/operators';
import { DOCUMENT } from '@angular/platform-browser';
import { SearchService } from 'src/app/services/search/search.service';
import { WindowService } from '@ng-toolkit/universal/ngt-universal/window.service';

@Component({
  selector: 'app-admin-questions',
  templateUrl: './admin-questions.component.html',
  styleUrls: ['./admin-questions.component.scss']
})
export class AdminQuestionsComponent implements OnInit {
  length = 0;
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 25, 100];

  // MatPaginator Output
  pageEvent: PageEvent = new PageEvent();

  excelData: AOA = [[1, 2], [3, 4]];
  manualPage = null;
  excelDataObject = [];

  options = ['1', '2', '3', '4'];
  choices = ['Single Choice', 'Multiple Choice'];
  difficultyLevels = ['Easy', 'Medium', 'Hard', 'Very Hard'];
  // categories = ['Data Structure', 'Functional', 'Algorithm', 'Object', 'Design Patterns'];

  questionList = [];
  public codeMirror: any;
  public editor: any;
  checkedAll = false;
  
  showErrorMsg: boolean = false;
  toBeSearched :any;
  constructor(private router: Router, private httpService: HttpService,
    private localstorageService: LocalstorageService,
    private snackbar: MatSnackBar,
    private dialog: MatDialog,
    private spinnerService: Ng4LoadingSpinnerService,
    private searchService: SearchService,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.pageEvent.pageIndex = 0; 
    this.pageEvent.pageSize = 10;
   
    

 
  }

 
  //   //subscribes every changes of your route
  //  this.router.events.subscribe((event) => {
  //   if (event instanceof NavigationEnd){
  //      //scroll to top
  //      window.scrollTo(0,0);
  //   }
  // },


  
  ngOnInit() {
    this.getQuestionList();
    this.localstorageService.setData("localQuestion", []);
    this.view();
  }

  view(){
    this.searchService.currentMessage.subscribe(
      response=>{
        this.toBeSearched=response;
        console.log(this.toBeSearched);
      }
     );
  }


  goBack() {
    this.router.navigate(['admin/campaign']);
  }
  getQuestionList() {
    this.spinnerService.show();
    var contentBody = { url: "/questions", body: {} }
    this.httpService.httpGet(contentBody).subscribe(response => {
      console.log("success ", response);
      this.questionList = response.data;
      var localQuestion = this.localstorageService.getData("localQuestion");
      console.log("localQuestion :", localQuestion);
      if (localQuestion != null && localQuestion != "") {
        this.excelDataObject = localQuestion;
        this.questionList = localQuestion.concat(this.questionList);
       
      }
      else {
        this.excelDataObject = []
      }
      this.length = this.questionList.length;
      this.spinnerService.hide();
    }, err => {
      this.spinnerService.hide();
      // Duplicate question
      this.openSnackBar(err.error.message)
      console.log("err ", err);
    })
  }

  onFileChange(evt: any) {
    /* wire up file reader */
    const target: DataTransfer = <DataTransfer>(evt.target);
    if (target.files.length !== 1) throw new Error('Cannot use multiple files');
    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      /* read workbook */
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

      /* grab first sheet */
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];

      /* save data */
      this.excelData = <AOA>(XLSX.utils.sheet_to_json(ws, { header: 1 }));
      console.log(this.excelData)
      this.parseExcelData(this.excelData);
    };
    reader.readAsBinaryString(target.files[0]);
  }

  parseExcelData(data) {
    this.excelDataObject = [];
    var missingColumns = "";
    if (data.length > 0) {
      if (data[0].indexOf("Question") == -1) {
        missingColumns += " Question,";
      }
      if (data[0].indexOf("Program") == -1) {
        missingColumns += " Program,";
      }
      if (data[0].indexOf("Op1") == -1) {
        missingColumns += " Op1,";
      }
      if (data[0].indexOf("Op2") == -1) {
        missingColumns += " Op2,";
      }
      if (data[0].indexOf("Op3") == -1) {
        missingColumns += " Op3,";
      }
      if (data[0].indexOf("Op4") == -1) {
        missingColumns += " Op4,";
      }
      if (data[0].indexOf("Op5") == -1) {
        missingColumns += " Op5,";
      }
      if (data[0].indexOf("Answer") == -1) {
        missingColumns += " Answer,";
      }
      if (data[0].indexOf("Complexity") == -1) {
        missingColumns += " Complexity,";
      }
      if (data[0].indexOf("OptionsType") == -1) {
        missingColumns += " OptionsType,";
      }
      if (data[0].indexOf("Topic") == -1) {
        missingColumns += " Topic,";
      }

      if (missingColumns != "") {
        // error msg
        missingColumns = missingColumns.slice(0, -1);
        this.openSnackBar("Please provide " + missingColumns + " columns")
        console.log(missingColumns);
        return false;
      }
      else {
        var headerRow = data[0];
        for (var i = 1; i < data.length; i++) {
          var oneObj = {
            "isLocal": "1", "isSelected": false, "question": "", "program": "",
            "options": [],
            "answers": [], "complexity": "1", "optionType": "", "topic": ""
          };
          var row = data[i];
          console.log(row.length);
          if (row != null && row != undefined && row.length > 0) {
            console.log("innnn")
            for (var j = 0; j < row.length; j++) {
              if (headerRow[j] == "Question") {
                oneObj.question = row[j]
              }
              if (headerRow[j] == "Program") {
                oneObj.program = row[j]
              }
              if (headerRow[j] == "Topic") {
                if (row[j] != undefined && row[j] != null && String(row[j]).trim() != "") {
                  oneObj.topic = row[j];
                }
              }
              if (headerRow[j] == "Op1") {
                if (row[j] != undefined && row[j] != null && String(row[j]).trim() != "") {
                  var op1 = { "id": "op1", "value": String(row[j]) }
                  oneObj.options.push(op1)
                }
              }
              if (headerRow[j] == "Op2") {
                if (row[j] != undefined && row[j] != null && String(row[j]).trim() != "") {
                  var op2 = { "id": "op2", "value": String(row[j]) }
                  oneObj.options.push(op2)
                }
                // oneObj.options[1].value = row[j]
              }
              if (headerRow[j] == "Op3") {
                if (row[j] != undefined && row[j] != null && String(row[j]).trim() != "") {
                  var op3 = { "id": "op3", "value": String(row[j]) }
                  oneObj.options.push(op3)
                }
                // oneObj.options[2].value = row[j]
              }
              if (headerRow[j] == "Op4") {
                if (row[j] != undefined && row[j] != null && String(row[j]).trim() != "") {
                  var op4 = { "id": "op4", "value": String(row[j]) }
                  oneObj.options.push(op4)
                }
                // oneObj.options[3].value = row[j]
              }
              if (headerRow[j] == "Op5") {
                if (row[j] != undefined && row[j] != null && String(row[j]).trim() != "") {
                  var op5 = { "id": "op5", "value": String(row[j]) }
                  oneObj.options.push(op5)
                }
                // oneObj.options[4].value = row[j]
              }
              if (headerRow[j] == "Answer") {
                if (row[j] != undefined) {
                  row[j] = row[j].replace(/(?:\r\n|\r|\n)/g, '');
                  // console.log("innnnn",row[j])
                  var res = row[j].toLowerCase().split(",");
                  oneObj.answers = res;
                }
                else {
                  oneObj.answers = [];
                }
              }
              if (headerRow[j] == "Complexity") {
                oneObj.complexity = String(row[j])
              }
              if (headerRow[j] == "OptionsType") {
                oneObj.optionType = row[j]
              }
              if (headerRow[j] == "Topic") {
                oneObj.topic = row[j]
              }
            }
            this.excelDataObject.push(oneObj);
          }


        }
        this.localstorageService.setData("localQuestion", JSON.stringify(this.excelDataObject));
        this.questionList = this.questionList.filter(function (question) {
          return question.isLocal != "1";
        });


        this.questionList = this.excelDataObject.concat(this.questionList);
        // this.questionList=this.excelDataObject;
        // this.saveQuestionListDataApi(this.excelDataObject);
      }
    }
    console.log("Parsed data : ", this.excelDataObject)

  }

 

  saveQuestionListDataApi() {
    console.log(this.questionList);

    var showErrorMsg = false;
    var selectedQuestionForAnswer = "";
    var updatableQuestion = this.questionList.filter(function (question) {
      return question.isLocal == "1" && question.isSelected == true;
    });
    console.log(updatableQuestion);
    if (updatableQuestion.length > 0) {
      for (let i = 0; i < this.questionList.length; i++) {

        if (this.questionList[i].isLocal == "1" && this.questionList[i].isSelected == true) {
          var loopError = false;
          console.log("this.questionList[i].question", this.questionList[i].question);

          if (this.questionList[i].question == null || this.questionList[i].question == undefined ||
            this.questionList[i].question.trim() == '') {
            loopError = true;
            showErrorMsg = true
          }

          if (this.questionList[i]["answers"].length <= 0) {
            loopError = true;
            showErrorMsg = true
          }
          console.log("this.questionList[i]", this.questionList[i]);
          if (this.questionList[i].topic !== undefined && this.questionList[i].topic !== null) {
            if (this.questionList[i].topic.trim() == "") {
              loopError = true;
              showErrorMsg = true;
            }
          }
          if (this.questionList[i].options.length < 2) {
            loopError = true;
            showErrorMsg = true
          }
          for (let j = 0; j < this.questionList[i].options.length; j++) {
            if (this.questionList[i].options[j].value.trim() == "") {
              loopError = true;
              showErrorMsg = true;
            }
            for (let k = 0; k < this.questionList[i].options.length; k++) {
              if (this.questionList[i].options[j].id != this.questionList[i].options[k].id &&
                String(this.questionList[i].options[j].value) == String(this.questionList[i].options[k].value)) {
                loopError = true;
                showErrorMsg = true;
              }
            }
          }
          if (loopError) {
            selectedQuestionForAnswer += " " + (i + 1) + ",";
          }
        }


      }


      if (showErrorMsg === false) {
        // console.log("iiiiiiiii");

        var contentBody = { url: "/questions", body: { "adminQuestions": updatableQuestion } }
        console.log(contentBody);
        this.httpService.httpPost(contentBody, false).subscribe(response => {
          console.log("success ", response);
          var localQuestion = this.questionList.filter(function (question) {
            return question.isLocal == "1" && question.isSelected != true;
          });
          this.checkedAll = false;
          this.localstorageService.setData("localQuestion", JSON.stringify(localQuestion));
          this.getQuestionList();
          // window.location.reload();
        }, err => {
          this.openSnackBar(err.error.message)
          console.log("err ", err);
        })
      }
      else {
        selectedQuestionForAnswer = selectedQuestionForAnswer.slice(0, -1);
        this.openSnackBar("Please correct the question no " + selectedQuestionForAnswer);
      }

    }
    else {
      this.openSnackBar("Please select atleast 1 question to publish.")
    }
  }


  makeQuestionEditable(index, question) {
    console.log("question", this.questionList);

    if (this.questionList[index].isEditable === false || this.questionList[index].isEditable === undefined) {
      this.questionList[index].isEditable = true;
    }
    else {
      this.questionList[index].isEditable = false;
    }
  }



  addOption(index) {
    // this.questionList[index].answers = [];
    var currentQuestion = this.questionList[index];

    var newOptList = [];
    var number = 0;
    for (var i = 0; i < currentQuestion.options.length; i++) {
      if (currentQuestion.options[i].value != null && currentQuestion.options[i].value != undefined) {
        number++;
        var newOpt = { id: "op" + number, value: currentQuestion.options[i].value };
        newOptList.push(newOpt);
      }
    }
    this.questionList[index].options = newOptList;

    if (currentQuestion.options.length < 5) {
      var newOpt1 = { id: "op" + currentQuestion.options.length + 1, value: "" };
      this.questionList[index].options.push(newOpt1);

    }
  }

  removeOption(qindex, oindex) {
    // this.questionList[qindex].answers = [];
    var currentQuestion = this.questionList[qindex];
    if (currentQuestion.options.length > 1) {
      currentQuestion.options[oindex].value = undefined;
    }
    var newOptList = [];
    var number = 0;
    for (var i = 0; i < currentQuestion.options.length; i++) {
      if (currentQuestion.options[i].value != null && currentQuestion.options[i].value != undefined) {
        number++;
        var newOpt = { id: "op" + number, value: currentQuestion.options[i].value };
        newOptList.push(newOpt);
      }
    }
    this.questionList[qindex].options = newOptList;
  }

  selectionChangeForSingleMultiple(e, index) {
    // console.log(e.value)
    this.questionList[index].answers = [];
  }

  removeQuestion(index) {

    var currentQuestion = this.questionList[index];
    console.log("cuurent question : ", currentQuestion)
    if (currentQuestion.isLocal != undefined && currentQuestion.isLocal != null && currentQuestion.isLocal == '1') {
      this.questionList.splice(index, 1);
      // this.excelDataObject.splice(index, 1);
      var localQuestion = this.questionList.filter(function (question) {
        return question.isLocal == "1";
      });
      this.localstorageService.setData("localQuestion", JSON.stringify(localQuestion));
    }
    else {
      // apicalls
      var contentBody = { url: "/questions/" + currentQuestion.id }
      this.httpService.httpDelete(contentBody).subscribe(response => {
        console.log("success single ", response);
        this.questionList.splice(index, 1);
      }, err => {
        console.log("err ", err);
      })
    }

  }

  saveSingleQuestionApi(index) {
    var currentQuestion = this.questionList[index];
    console.log("cuurent question : ", currentQuestion)
    if (currentQuestion.isLocal != undefined && currentQuestion.isLocal != null && currentQuestion.isLocal == '1') {
      var loopError = false;
      if (this.questionList[index].question == null || this.questionList[index].question == undefined ||
        this.questionList[index].question.trim() == '') {
        loopError = true;
      }
      if (this.questionList[index]["answers"].length <= 0) {
        loopError = true;
      }
      for (let j = 0; j < this.questionList[index].options.length; j++) {
        if (this.questionList[index].options[j].value.trim() == "") {
          loopError = true;
        }
        for (let k = 0; k < this.questionList[index].options.length; k++) {

          if (this.questionList[index].options[j].id != this.questionList[index].options[k].id &&
            String(this.questionList[index].options[j].value) == String(this.questionList[index].options[k].value)) {
            loopError = true;
          }
        }
      }
      if (loopError) {
        this.openSnackBar("Please correct the question no " + (index + 1));
        return false;
      }
      console.log("vlaeee ", loopError)
      this.questionList[index].isEditable = false;
    }
    else {
      // apicalls
      var loopError = false;
      if (this.questionList[index].question.trim() == '') {
        loopError = true;
      }
      if (this.questionList[index]["answers"].length <= 0) {
        loopError = true;
      }

      if (this.questionList[index].options.length < 2) {
        loopError = true;
      }
      for (let j = 0; j < this.questionList[index].options.length; j++) {
        if (this.questionList[index].options[j].value.trim() == "") {
          loopError = true;
        }
        for (let k = 0; k < this.questionList[index].options.length; k++) {
          if (this.questionList[index].options[j].id != this.questionList[index].options[k].id
            && String(this.questionList[index].options[j].value) == String(this.questionList[index].options[k].value)) {
            loopError = true;
          }
        }
      }
      if (loopError) {
        this.openSnackBar("Please correct the question no " + index + 1);
        return false;
      }
      else {

        var contentBody = { url: "/questions/" + currentQuestion.id, body: currentQuestion }
        this.httpService.httpPost(contentBody, false).subscribe(response => {
          console.log("success single ", response["question"]);
          this.questionList[index] = response["question"];
          this.questionList[index].isEditable = false;

        }, err => {
          console.log("err ", err);
        })
      }
    }
  }
 
  optionCheckBoxChange(e, optVal, index) {
    console.log(e.checked)
    console.log(optVal)
    console.log(index)

    if (e.checked) {
      if (this.questionList[index].answers.indexOf(optVal) > -1) {

      }
      else {
        this.questionList[index].answers.push(optVal);
      }
    }
    else {
      if (this.questionList[index].answers.indexOf(optVal) > -1) {
        this.questionList[index].answers.splice(this.questionList[index].answers.indexOf(optVal), 1);
      }
      else {
      }
    }
    console.log(this.questionList[index])
  }

  openSnackBar(message: string) {
    if (message) {
      this.snackbar.open(message, null, {
        duration: 2000,
      });
    }
    else {
      this.snackbar.open('Network Error', null, {
        duration: 2000,
      });
    }
  }


  selectOnePage(e) {
    console.log(this.pageEvent.pageIndex)
    console.log(this.checkedAll)
    if (e.checked) {
      for (var i = this.pageEvent.pageIndex * this.pageEvent.pageSize; i < this.pageEvent.pageIndex *
        this.pageEvent.pageSize + this.pageEvent.pageSize; i++) {
        if (this.questionList[i].isLocal != undefined && this.questionList[i].isLocal != null && this.questionList[i].isLocal == "1") {
          this.questionList[i].isSelected = true;
        }
      }
    }
    else {
      for (var i = this.pageEvent.pageIndex * this.pageEvent.pageSize; i < this.pageEvent.pageIndex *
        this.pageEvent.pageSize + this.pageEvent.pageSize; i++) {
        if (this.questionList[i].isLocal != undefined && this.questionList[i].isLocal != null && this.questionList[i].isLocal == "1") {
          this.questionList[i].isSelected = false;
        }
      }
    }
  }
  selectAllPage(e) {
    console.log(this.pageEvent.pageIndex)
    console.log(this.checkedAll)
    if (e.checked) {
      for (var i = 0; i < this.questionList.length; i++) {
        if (this.questionList[i].isLocal != undefined && this.questionList[i].isLocal != null && this.questionList[i].isLocal == "1") {
          this.questionList[i].isSelected = true;
        }
      }
    }
    else {
      for (var i = 0; i < this.questionList.length; i++) {
        if (this.questionList[i].isLocal != undefined && this.questionList[i].isLocal != null && this.questionList[i].isLocal == "1") {
          this.questionList[i].isSelected = false;
        }
      }
    }
  }
  selectAllPage_old() {
    console.log(this.pageEvent.pageIndex)
    console.log(this.checkedAll)
    for (var i = 0; i < this.questionList.length; i++) {
      if (this.questionList[i].isLocal == "1") {
        this.questionList[i].isSelected = true;
      }
    }
    // }
    // else{
    //   for(var i=0 ;i<this.questionList.length ;i++){
    //     if(this.questionList[i].isLocal=="1"){
    //       this.questionList[i].isSelected=false;
    //     }
    //   }
    // }
  }

  openAddQuestion() {
    const dialogRef = this.dialog.open(AddIndividualQuestionComponent,  {
      width: '786px'
    
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });

  }
  top(){
   
    window.scrollTo(0,0)
  }
}

